var _style, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#6366F1;}\r\n\t.st1{fill:#4F46E5;}\r\n\t.st2{fill:#A0A3FE;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_2_00000155831642637660852670000000826477612792105104_"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Calque_3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M40.4,36.4c-3.4,3.8-8,5.8-13.2,5.8c-9.7,0-17.9-7.8-17.9-17.1c0-9.2,8.3-17,18-17c3.8,0,7.3,1.1,10.2,3.2 l4.1-5.7c-4.1-3-9.1-4.5-14.3-4.5c-13.6,0-25,11-25,24c0,13.1,11.4,24.1,24.9,24.1c7.2,0,13.5-2.8,18.3-8.1L40.4,36.4z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M29.3,36c-4,0-10.5-2.7-10.5-9.9c0-5,4.1-9.3,9.2-9.6c4.7-0.2,6.1,1.2,8.6,3.7l7.8-7.8 c-3.1-3.1-7.3-7.3-16.9-6.9C16.7,6,7.8,15.3,7.8,26.1c0,13.1,11,20.9,21.5,20.9c4.3,0,10.3-2.4,13.2-5.3l-7.8-7.8 C33.9,34.7,30.8,36,29.3,36z"
  }))))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Calque_1_00000022554034396340595430000004555754886061240979_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M27.3,42.2c-9.7,0-17.9-7.8-17.9-17.1c0-9.2,8.3-17,18-17c3.8,0,7.3,1.1,10.2,3.2l2.1-2.9 c-2.8-1.8-6.5-3.1-12.1-2.9C16.7,6,7.8,15.3,7.8,26.1c0,13.1,11,20.9,21.5,20.9c4.3,0,10.3-2.4,13.2-5.3L38.8,38 C35.6,40.7,31.7,42.2,27.3,42.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.8b9339f7398548f69ce2ca824978faf3.svg";
export { ForwardRef as ReactComponent };